import * as React from 'react'
import { signOut } from '../../utils/auth'
import Logo from '../icons/ui/LogoGoin'
import Logout from '../icons/ui/ArrowRight'

const DriverLandingPage = (props: { user: any }) => {
  return (
    <div
      className='absolute top-0 bottom-0 left-0 right-0 flex flex-column justify-center items-center'
      style={{
        backgroundImage: `url('/images/driver/landing.webp')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
    >
      {/* <div className='absolute top-0 right-0 mt2 mr3 font-white flex' onClick={signOut}>
        Logout <Logout className='ml1' width={10} fill='white' />
      </div> */}
      <Logo className='icon--89x137 mb2' />
      <h1 className='font-white mb2'>Welcome to Goin!</h1>
      <div className='flex items-center'>
        <img src='/images/driver/app-0.webp' className='mr4' />
        <div className='flex flex-column'>
          <a href='https://play.google.com/store/apps/details?id=com.goinprovider&hl=en' className='mb3 w100'>
            <img
              className='w100'
              src='https://lh3.googleusercontent.com/qF9r3ZjtgG-qyHdmjecArtKiulz1gmwL_xl9R3_fzk6igSeoN0wYbJSKEX5d_fxJRwYZJpHbqcLB3i9atl-9dOfUl9an7U43TfZ9PtQ=s0'
            />
          </a>
          <span className='mb2 font-white'>Comming soon!</span>
          <img className='mb4 w100' src='/images/driver/appstore.svg' />
        </div>
      </div>
    </div>
  )
}

export default DriverLandingPage



// WEBPACK FOOTER //
// ./src/components/drivers/LandingPage.tsx